export const textEllipsis = (value, charCount) => {
    const text = value || '';
    return text.length > charCount ? `${text.substring(0, charCount)}...` : text
};